import { cast, types } from 'mobx-state-tree';

export const HandleGesture = types
  .model({
    bulkUpload: types.boolean,
    gestureForUnAssigned: types.boolean,
    gestureForReAssign: types.boolean,
    gestureForSignAndStamp: types.boolean,
    isLIstampingRequired: types.boolean,
    comingFromWorkPackage: types.boolean,
    isDefaultLiSignAndStamp: types.boolean,
    inspectionIds: types.array(types.number),
    taskIds: types.array(types.number),
    selectAll: types.boolean,
    inspectionStatusId: types.number,
    isCompleted: types.boolean,
    runOnInspectionSub: types.boolean,
    runOnTaskSub: types.boolean,
    runOnDeletion: types.boolean,
    isManualSyncClicked: types.boolean,
    errorInManualSync: types.boolean,
    lastManualSync: types.number,
    handleAccordion: types.array(types.string),
    tasksforReAssignAndSign: types.array(
      types.model({
        inspectionId: types.number,
        taskId: types.number,
        fieldInspectorId: types.maybeNull(types.number),
        leadInspectorId: types.number,
        taskStatusId: types.number,
        inspectionStatusId: types.number,
        isLiFiScSame: types.boolean,
        clerkId: types.maybeNull(types.number),
      }),
    ),
    isNotificationClicked: types.boolean,
  })
  .views(() => ({}))
  .actions(self => ({
    setTasksForReAssignAndSign: (
      newTask: {
        inspectionId: number;
        taskId: number;
        fieldInspectorId?: number;
        leadInspectorId: number;
        taskStatusId: number;
        inspectionStatusId: number;
        isLiFiScSame: boolean;
        clerkId?: number;
      },
      flag: boolean,
    ) => {
      if (flag) {
        if (!self.tasksforReAssignAndSign.find(task => task.taskId === newTask.taskId)) {
          self.tasksforReAssignAndSign.push(newTask);
        }
      } else {
        self.tasksforReAssignAndSign = cast(
          self.tasksforReAssignAndSign.filter(task => task.taskId !== newTask.taskId),
        );
      }
    },
    setGestureForUnAssigned: (flag: boolean) => {
      self.gestureForUnAssigned = flag;
      self.bulkUpload = flag;
    },
    setGestureForReAssign: (flag: boolean) => {
      self.gestureForReAssign = flag;
      self.bulkUpload = flag;
    },
    setGestureForSignAndStamp: (flag: boolean) => {
      self.gestureForSignAndStamp = flag;
      self.bulkUpload = flag;
    },
    setIsLIstampingRequired: (flag: boolean) => {
      self.isLIstampingRequired = flag;
    },
    setIsDefaultLiSignAndStamp: (flag: boolean) => {
      self.isDefaultLiSignAndStamp = flag;
    },
    setcomingFromWorkPackage: (flag: boolean) => {
      self.comingFromWorkPackage = flag;
    },
    setIsNotificationClicked: (flag: boolean) => {
      self.isNotificationClicked = flag;
    },
    insertIntoInspectionId: (id: number) => {
      if (self.inspectionIds.find(element => element === id) === undefined)
        self.inspectionIds.push(id);
    },
    insertIntoAccordion: (id: string) => {
      if (self.handleAccordion.find(element => element === id) === undefined)
        self.handleAccordion.push(id);
    },
    removeFromAccordion: (id: string) => {
      self.handleAccordion.remove(id);
    },
    removeFromInspectionId: (id: number) => {
      self.inspectionIds.remove(id);
    },
    resetInspectionId: () => {
      self.inspectionIds.clear();
      self.isLIstampingRequired = false;
    },
    insertIntoTaskId: (id: number) => {
      if (self.taskIds.find(element => element === id) === undefined) self.taskIds.push(id);
    },
    removeFromTaskId: (id: number) => {
      self.taskIds.remove(id);
    },
    resetTaskId: () => {
      self.taskIds.clear();
    },
    resetTaskForReAssignAndSign: () => {
      self.tasksforReAssignAndSign.clear();
    },
    changeSelectAll: (flag: boolean) => {
      self.selectAll = flag;
    },
    setInspectionStatusId: (id: number) => {
      self.inspectionStatusId = id;
    },
    setIsCompleted: (flag: boolean) => {
      self.isCompleted = flag;
    },
    setRunOnInspectionSubscription: (flag: boolean) => {
      self.runOnInspectionSub = flag;
    },
    setRunOnTaskSubscription: (flag: boolean) => {
      self.runOnTaskSub = flag;
    },
    setRunOnDeletion: (flag: boolean) => {
      self.runOnDeletion = flag;
    },
    setManualSyncClicked: (flag: boolean) => {
      self.isManualSyncClicked = flag;
    },
    setErrorInManualSync: (flag: boolean) => {
      self.errorInManualSync = flag;
    },
    setManualSync: (time: number) => {
      self.lastManualSync = time;
    },
    resetEverything: () => {
      self.inspectionIds.clear();
      self.taskIds.clear();
      self.handleAccordion.clear();
      self.gestureForReAssign = false;
      self.gestureForUnAssigned = false;
      self.gestureForSignAndStamp = false;
      self.isLIstampingRequired = false;
      self.comingFromWorkPackage = false;
      self.isDefaultLiSignAndStamp = false;
      self.bulkUpload = false;
      self.selectAll = false;
      self.tasksforReAssignAndSign.clear();
    },
  }));

export default HandleGesture;
